import React from "react";
import loadingIcon from "../../assets/images/loading.gif";

const SmuButton = ({ control, children, _className, loading, disabled = false, highlightPin= false, loadingPercent=null, loadingPercentPosition="none" }) => {
  return (
    <>
    <button
      type="button"
      className={`smu-button-table ${_className || ""}`}
      onClick={control}
      disabled={disabled}
    >
      {!loading ? (
        children
      ) : (
        <img src={loadingIcon} alt="Cargando" width={18} />
      )}
    </button>

    {highlightPin && (
        <>
          <span className="pin" style={{
            position: "absolute", zIndex: 2, background: "#FF6A55", borderRadius: "50%",
            ...(loadingPercentPosition === "top"
              ? { top: "2px", left: "44px", width: "13px", height: "13px" }
              : loadingPercentPosition === "bottom"
                ? { top: "-4px", right: "-4px", width: "13px", height: "13px" }
                : { display: "none" }),
            borderColor: "#ffffff", borderStyle: "solid", borderWidth: "medium",
            pointerEvents: "none"
          }} />
        </>
      )}

      {loading && loadingPercent !== null &&(
        <>
          <span className="loadingPercent text-muted" style={{
              position: "absolute", zIndex: 3, background: "#ffffff", borderRadius: "22%",
              ...(loadingPercentPosition === "top"
                ? { top: "4px", left: "40px", width: "34px", height: "18px", textAlign: "center" }
                : loadingPercentPosition === "bottom"
                  ? { top: "31px", right: "3px", width: "30px", height: "17px", textAlign: "center" }
                  : { display: "none" }),
              borderColor: "#FF6A55", borderStyle: "solid", borderWidth: "thin",
              fontWeight: "bolder", fontSize: "x-small", alignContent: "center"
            }}>{loadingPercent}%</span>
        </>
      )}
    </>
  );
};

export default SmuButton;
